(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-jp-product-action]').forEach((action) => {
      if (action.dataset.jpActionReady === 'true') return;
      action.dataset.jpActionReady = 'true';

      const details = action.querySelector('details');
      const trigger = action.querySelector('summary');
      const urlInput = action.querySelector('[data-jp-action-url]');
      const message = action.querySelector('[data-jp-action-message]');
      const nativeButton = action.querySelector('[data-jp-action-native]');

      action.querySelector('[data-jp-action-close]')?.addEventListener('click', () => {
        details.open = false;
        trigger.focus();
      });
      action.querySelector('[data-jp-action-copy]')?.addEventListener('click', async () => {
        if (!urlInput) return;
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(urlInput.value);
          } else {
            urlInput.select();
            if (!document.execCommand('copy')) throw new Error('Copy unavailable');
          }
          if (message) {
            message.textContent = action.dataset.copied || 'Link copied';
            message.hidden = false;
          }
        } catch (error) {
          urlInput.focus();
          urlInput.select();
        }
      });
      urlInput?.addEventListener('click', () => urlInput.select());
      details?.addEventListener('toggle', () => {
        if (!details.open && message) {
          message.hidden = true;
          message.textContent = '';
        }
      });
      details?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          trigger.focus();
        }
      });

      if (nativeButton) {
        nativeButton.hidden = typeof navigator.share !== 'function';
        action.querySelector('.jp-product-action__options')
          ?.classList.toggle('jp-product-action__options--single', nativeButton.hidden);
        if (!nativeButton.hidden) {
          nativeButton.addEventListener('click', async () => {
            try {
              await navigator.share({
                title: action.dataset.title || document.title,
                url: urlInput.value,
              });
            } catch (error) {
              if (error?.name !== 'AbortError') urlInput?.focus();
            }
          });
        }
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
